import axios from 'axios';
import CryptoJS from 'crypto-js';
import sha1 from 'crypto-js/sha1';
import aes from 'crypto-js/aes';

const baseDomain = process.env.VUE_APP_API_SERVER_URL;
const baseURL = `${baseDomain}/api/v1`;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const instance = axios.create({
  baseURL,
  timeout: 25000,
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  }
});
let s;
const vk = (m) => {
  const k = (o) => {
    const t = parseInt(Math.ceil(((new Date()) * .001) / 60 / 60 / 6)) + (o || 0);
    const key = 'sr_encrypt'
      + (t).toString()
      + (parseInt(Math.ceil(Math.sin(t) * 125))).toString()
      + (parseInt(Math.ceil(Math.cos(t) * 375))).toString()
      + (t << 5).toString()
      + (t | 3).toString();
    return sha1(
      key
    ).toString().substr(0, 32);
  }
  if (s && sha1(s).toString().substr(10, 4) === m) {
    return s;
  }
  let r;
  [0, -1, -2, -3, 1, 2].every((o) => {
    const c = k(o);
    if (sha1(c).toString().substr(10, 4) === m) {
      s = r = c;
      return false;
    }
    return true;
  })
  return r;
}
instance.interceptors.request.use(c => {
  c.url = c.url + (c.url.indexOf('?') === -1 ? '?' : '&') + 'ht=' + btoa(Math.ceil(((new Date()) * .001) / 60 / 60 / 2 + 12).toString(16)).replace(/=/g, '');
  return c;
});

instance.interceptors.response.use((response) => {
  const key = vk(response.data.substr(0, 4));
  if (key === undefined) {
    return response;
  }
  let d = aes.decrypt(
    response.data.substr(4),
    key
  ).toString(CryptoJS.enc.Utf8);
  if (d) {
    try {
      d = JSON.parse(d);
    } catch (e) {
      return response;
    }
    response.data = d;
  }
  return response;
})

export default instance;
